"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.progress.title': 'Trening Modelu',
    'trainer.progress.start': 'Rozpocznij Trening',
    'trainer.progress.stop': 'Zatrzymaj Trening',
    'trainer.progress.new': 'Nowy Trening',
    'trainer.progress.title.text': 'Postęp Treningu',
    'trainer.progress.metric.epoch': 'Aktualna Epoka:',
    'trainer.progress.metric.loss': 'Strata:',
    'trainer.progress.metric.accuracy': 'Dokładność:',
    'trainer.progress.metric.time': 'Pozostały Czas:',
};
